/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_History_SearchInputs */



/**
* | output |
* | --- |
* | "Search chats" |
*
* @param {Assistant_History_SearchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_history_search = /** @type {((inputs?: Assistant_History_SearchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_History_SearchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recherche de discussions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Chats durchsuchen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca chat")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поиск в чатах")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar chats")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索聊天记录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チャットを検索")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चैट खोजें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pesquisar chats")
	return /** @type {LocalizedString} */ ("Search chats")
});